export const useIsDemoThread = (threadId: string | null) => {
  if (!threadId) {
    return false;
  }

  return threadId === 'onboarding-thread';
};
